module.exports = __webpack_public_path__ + "static/commerce2x-commerce-three-a6d12f9b0d25f159940c79bd615c8848.jpg";